import {
    ChangeDetectionStrategy,
    Component,
    Input,
    Output,
    EventEmitter,
} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Component({
    selector: 'biolink-slideout-panel',
    templateUrl: './biolink-slideout-panel.component.html',
    styleUrls: ['./biolink-slideout-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BiolinkSlideoutPanelComponent {
    @Input() title: string;
    @Output() closed = new EventEmitter();
    visible$  = new BehaviorSubject<boolean>(false);
}
